import { subscribe, useSnapshot } from "valtio"
import { useEffect, useState } from "react"
import { AgmodalStore, configStore, loginStore } from "../state/CommonState";
import TaskDatetime from "./task-datetime";
import Taskfileapproval, { validateFileApproval } from "./task-file-approval";
import Taskfiledisplay from "./task-file-display";
import Taskfiletable from "./task-file-table";
import { taskStore } from "./task-store";
import Taskapi from "./tasks-api";
import Api from "../state/Api";
import CiplVerification, { queueCiplVerification } from "./cipl-verification";
import MonApi, { CLEAR_BOOKING_COMMERCIAL_INVOICE_AND_PACKING_LIST_URI, GET_SH_ENTITIES_BY_FILTER_URI } from '../state/mongo-api';
async function callback(e) {
    taskStore.current.stage = 2
    taskStore.current.pendingWith = process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE.toUpperCase()
    taskStore.setCustomerComplete()
    await Taskapi.updateTask(taskStore.current)
    queueCiplVerification(taskStore.current)
    taskStore.triggerActionVisible = false
    taskStore.myActionVisible = false
    if(AgmodalStore.modalPage === "TaskContainer" || loginStore.isClient()){
        AgmodalStore.pageVisible = false
        AgmodalStore.apiCall = true
    }
}
export default function Ciplupload(props) {
    useSnapshot(taskStore)
    useSnapshot(configStore)
    useSnapshot(AgmodalStore)
    let task = taskStore.current
    let stage = task.stage
    const [disableButton, setDisableButton] = useState(true)
    const [rejected, setrejected] = useState(false)
    const [invoiceData, setInvoiceData] = useState();
    const [verifying, setVerifying] = useState(false)

    useEffect(() => {
        if (task?.bookingNum) {
          Api.getInvoiceData(
            { bookingNum: task.bookingNum,actionName:'COI Creation (Insurance)' },
            async (data) => {
              setInvoiceData(data.data);
            }
          );
        }
      }, [task?.bookingNum]);
      
      useEffect(()=>{
        if(invoiceData && invoiceData?.files && invoiceData?.files.length>0 && stage===1 && !rejected ){
            const updatedFiles = invoiceData?.files.filter(e => e.label === 'Commercial Invoice')
            .map(file => ({
                ...file,
                nonEditable: true,
                approved: 'Approve',
            }))
            task.files = [...task.files,...updatedFiles]          
        }
      },[invoiceData])
    
    function check(){
        let disable = false
        let reject = false
        let checkfile = []
        if(taskStore.current.files.length==0){
            disable = true
        }
        taskStore.current.files.map((e) =>{
            if(e.filename.length==0){
                disable = true
            }
            if(e.approved =="Reject"){
                reject = true
            }
            if(checkfile.indexOf(e.label) == -1){
                if(taskStore.current.original_file.indexOf(e.label) != -1 && e.filename.length==0){
                    disable = true
                }else{
                    if(taskStore.current.original_file.indexOf(e.label) != -1){
                        checkfile.push(e.label)
                    }
                }
            }
        })
        setrejected(reject)
        setDisableButton(disable)
    }
    useEffect(() => {
        check()
        let unsubscribe = subscribe(taskStore.current, () => {
            check()
        })
        return unsubscribe
    }, [taskStore.current])

    if (stage === 1) {
        return (
            <div className="box">
                {
                    (!loginStore.isClient() && rejected && task?.rejectedBy )?<p>The document was rejected by <strong>{task.rejectedBy}</strong>. Please see reason below.
                </p>:<p>
                    Please Upload your Commercial Invoice(s) & Packing List(s)
                </p>
                }
                {
                    (rejected)?<Taskfiletable showRejectReason={true} nonEditable={true} />:<Taskfiletable nonEditable={true} />
                }
                
                <hr />
                <p>
                    <span>
                        <button style={{ float: 'left' }} className="button islink" disabled={disableButton}
                            onClick={callback}>Submit</button>
                    </span>
                </p>
            </div>
        )
    }
    if (stage === 2) {
        return (
            <>
            {
                (!loginStore.isClient() && rejected && task?.rejectedBy )?<p>The document was rejected by <strong>{task.rejectedBy}</strong>. Please see reason below.
                </p>:<></>
            }
                {!loginStore.isClient() && <CiplVerification task={task} onBusyChange={setVerifying} />}
                {/* Status, remarks and Save stay locked while the AI verification is running */}
                <fieldset disabled={verifying} style={{ border: 0, padding: 0, margin: 0, minWidth: 0, opacity: verifying ? 0.6 : 1 }}>
                    <Taskfileapproval />
                </fieldset>
                <p>
                    <span>
                        <button style={{ float: 'left' }} className="button islink" disabled={verifying}
                            onClick={async (e) => {
                                let task = taskStore.current
                                let ret = validateFileApproval(task)
                                if (ret.errors.length > 0) {
                                    configStore.setModalMessage(ret.errors.join(','))
                                    return
                                }
                                if (ret.rejected) {
                                    task.stage = 1
                                    task.pendingWith = 'CUSTOMER'
                                    task.customerStatus = 'PENDING'
                                    task.rejectedBy = loginStore.userRec.firstName+''+loginStore.userRec.lastName+'('+loginStore.email+')'
                                }
                                else {
                                    task.stage = 3
                                    taskStore.setComplete()
                                    await Api.triggerSBAction(taskStore.current.bookingNum)
                                    Api.sendCiplMismatchMail({ bookingNum: taskStore.current.bookingNum, taskNum: taskStore.current._id?.num })
                                    const entity = await MonApi.apost(GET_SH_ENTITIES_BY_FILTER_URI, {
  _id: taskStore.current.entityId
})
                                    if(entity.length > 0 && entity[0]?.customer?.crossBorder?.salesVertical!='MSME'){
                                       const files = taskStore.current.files.map((e)=>e.filename)
                                       MonApi.apost(CLEAR_BOOKING_COMMERCIAL_INVOICE_AND_PACKING_LIST_URI, {
  _id: taskStore.current.bookingNum
})
                                    }
                                }
                                await Taskapi.updateTask(taskStore.current)
                                // Accepted and saved: the server raises HTS Classification if the booking qualifies (US FPOD, DCC)
                                if (task.stage === 3) Api.triggerHtsAction(taskStore.current.bookingNum)
                                taskStore.triggerActionVisible = false
                                taskStore.myActionVisible = false
                                if(AgmodalStore.modalPage === "TaskContainer" || loginStore.isClient()){
                                    AgmodalStore.pageVisible = false
                                    AgmodalStore.apiCall = true
                                }
                            }}>Save</button>
                    </span>
                </p>
            </>
        )
    }
    if (task.stage >= 3) {
        return (
            <>
                {/* Approved: the AI verification is shown as it was, never re-checked */}
                {!loginStore.isClient() && <CiplVerification task={task} readOnly />}
                <Taskfiledisplay />
            </>
        )
    }
}
export function CipluploadTrigger(props) {
    useSnapshot(taskStore)
    useSnapshot(configStore)
    const [disableButton, setDisableButton] = useState(true)
    let task = taskStore.current
    let stage = task.stage
    useEffect(() => {
        let unsubscribe = subscribe(taskStore.current, () => {
            if (taskStore.current.dueDate.length > 0) {
                setDisableButton(false)
            }else{
                setDisableButton(true)
            }
        })
        return unsubscribe
    }, [taskStore.current])
    return (
        <>
            <TaskDatetime />
            <br /><br /><br />
            <p>
                <button className="button islink"
                    disabled={disableButton}
                    onClick={async (e) => {
                        taskStore.current.stage = 1
                        taskStore.current.pendingWith = 'CUSTOMER'
                        //await Taskapi.getEmailsForEntity(taskStore.current.gst)
                        setDisableButton(true)
                        await Taskapi.saveTask(taskStore.current)
                        taskStore.triggerActionVisible = false
                        taskStore.myActionVisible = false
                    }}>Trigger Action</button>
            </p>
        </>
    )
}